import CloseIcon from "@mui/icons-material/Close";
import { Chip, Stack } from "@mui/material";

import { MailList } from "api/memberPortal/mailList/mailList.types";
import { niapColorFamily } from "utils/color";

interface SelectedMailListChipsProps {
  selectedIds: number[];
  mailLists: MailList[];
  onRemove: (_id: number) => void;
}

export default function SelectedMailListChips({
  selectedIds,
  mailLists,
  onRemove,
}: SelectedMailListChipsProps) {
  if (selectedIds.length === 0) return null;

  const selectedLists = mailLists.filter((list) =>
    selectedIds.includes(list.id),
  );

  return (
    <Stack
      direction="row"
      flexWrap="wrap"
      gap={0.5}
      sx={{
        maxHeight: 100,
        overflowY: "auto",
      }}
    >
      {selectedLists.map((list) => {
        return (
          <Chip
            key={list.id}
            label={list.name}
            size="small"
            onDelete={() => onRemove(list.id)}
            deleteIcon={<CloseIcon fontSize="small" />}
            color={niapColorFamily(list.category?.themeColor ?? "ink")}
          />
        );
      })}
    </Stack>
  );
}
